module.exports = __webpack_public_path__ + "static/media/migrate-guru-plugin.a6462fce.png";